/**
 * Custom hook that blocks navigation when a condition is met
 * This uses React Router v6's official unstable_useBlocker hook
 */
// export function useBlocker(shouldBlock: boolean) {
//   const [isBlocked, setIsBlocked] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Use React Router's official blocker hook
//   const blocker = useRouterBlocker(
//     ({ currentLocation, nextLocation }) =>
//       shouldBlock && currentLocation.pathname !== nextLocation.pathname,
//   );

//   // Update our state when blocker state changes
//   useEffect(() => {
//     if (blocker.state === 'blocked') {
//       setIsBlocked(true);
//     } else {
//       setIsBlocked(false);
//     }
//   }, [blocker.state]);

//   // Handle browser navigation (back/forward buttons, closing tab)
//   useEffect(() => {
//     if (!shouldBlock) {
//       return;
//     }

//     const handleBeforeUnload = (e: BeforeUnloadEvent) => {
//       e.preventDefault();
//       e.returnValue = '';
//       return '';
//     };

//     window.addEventListener('beforeunload', handleBeforeUnload);
//     return () => {
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//     };
//   }, [shouldBlock]);

//   const proceed = useCallback(() => {
//     if (blocker.state === 'blocked') {
//       blocker.proceed();
//     }
//   }, [blocker]);

//   const reset = useCallback(() => {
//     if (blocker.state === 'blocked') {
//       blocker.reset();
//     }
//   }, [blocker]);

//   return { isBlocked, proceed, reset };
// }

/**
 * Custom hook that prompts the user before navigating away
 */
// export function usePrompt(message: string | ((location: Location) => string), when = true) {
//   const location = useLocation();
//   const blocker = useBlocker(when);

//   const handleConfirm = useCallback(() => {
//     blocker.proceed();
//   }, [blocker]);

//   const handleCancel = useCallback(() => {
//     blocker.reset();
//   }, [blocker]);

//   return {
//     showPrompt: blocker.isBlocked,
//     handleConfirm,
//     handleCancel,
//   };
// }

interface PromptProps {
  when: boolean;
  message: string | ((location: Location) => string);
}

/**
 * A replacement for React Router v5's Prompt component
 */
export const Prompt: React.FC<PromptProps> = () => <></>;

export default Prompt;
